import React, { useState, useEffect } from "react";
import {
  Table,
  Button,
  Modal,
  Input,
  message,
  Form,
  Card,
  Tooltip,
  Badge,
  Empty,
  Row,
  Col,
  Statistic,
  Spin
} from "antd";
import {
  SendOutlined,
  InfoCircleOutlined,
  DollarOutlined,
  CheckCircleOutlined,
} from "@ant-design/icons";
import "./transferenciaSucursal.css";
import NavbarMex from "../components/navbarMex";
import axios from "axios";
import { data } from "jquery";

const { TextArea } = Input;

const TransferenciaSucursal = () => {
  const [saldoDisponible, setSaldoDisponible] = useState(0);
  const [transferenciasEnviadas, setTransferenciasEnviadas] = useState([]);
  const [transferenciasRecibidas, setTransferenciasRecibidas] = useState([]);
  const [loading, setLoading] = useState(false);

  // Estados para el flujo de transferencia
  const [correoSucursal, setCorreoSucursal] = useState("");
  const [isCorreoModalVisible, setIsCorreoModalVisible] = useState(false);
  const [detalleSucursal, setDetalleSucursal] = useState(null);
  const [isDetalleModalVisible, setIsDetalleModalVisible] = useState(false);
  const [isTransferenciaModalVisible, setIsTransferenciaModalVisible] =
    useState(false);
  const [montoTransferencia, setMontoTransferencia] = useState("");
  const [descripcion, setDescripcion] = useState("");
  const [isConfirmModalVisible, setIsConfirmModalVisible] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [resumen, setResumen] = useState(null);
  const [responseSuccess, setResponseSuccess] = useState(false);
  const [isActiveTrasnferSucursal, setIsActiveTransferSucursal] = useState(0);
  const [sucursalCode, setSucursalCode] = useState(0);
  const [loadingActivationTransfer, setLoadinActivateTransfer] =
    useState(false);

  // Función para formatear el número a pesos colombianos
  const formatToCurrency = (value) => {
    if (!value) return "";
    // Eliminar cualquier caracter que no sea número
    const cleanValue = value.toString().replace(/[^\d]/g, "");
    // Formatear con puntos
    return new Intl.NumberFormat("es-CO").format(cleanValue);
  };

  // Función para limpiar el formato y obtener solo números
  const cleanCurrencyFormat = (value) => {
    return value.toString().replace(/[^\d]/g, "");
  };

  useEffect(() => {
    fetchSaldoDisponible();
    fetchTransferencias();
    getDataSucursal();
  }, []);
  useEffect(() => {
    fetchTransferencias();
  }, [responseSuccess]);

  const getDataSucursal = async () => {
    try {
      const user_id = localStorage.getItem("usuario_id");
      const token = localStorage.getItem("token");
      if (!token || !user_id) {
        message.error(
          "No se encontró el token de autenticación. Por favor, inicie sesión nuevamente."
        );
      }
      const fetchUrl = `https://99envios.app/api/online/sucursal/${user_id}`;
      const response = await axios.get(fetchUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      data = response.data;
      setIsActiveTransferSucursal(data.activo_transferencia);
      setSucursalCode(data.codigo_sucursal);
    } catch (error) {
      console.error("Error to fetch data sucursal", error);
    }
  };

  const activateTransferModule = async () => {
    const token = localStorage.getItem("token");
    const code = sucursalCode.toString();
    if (!token) {
      message.error(
        "No se encontró el token de autenticación. Por favor, inicie sesión nuevamente."
      );
      return;
    }
    const requestBody = {
      sucursal: code,
    };

    try {
      setLoadinActivateTransfer(true);
      const response = await axios.post(
        "https://99envios.app/api/online/transferencias/activar",
        requestBody,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 200) {
        message.success("Módulo activado correctamente correctamente.");
        setLoadinActivateTransfer(false);
      } else {
        message.error("Error al activar el módulo. Intente nuevamente.");
        setLoadinActivateTransfer(false);
      }
    } catch (error) {
      message.error("Error al activar el módulo. Intente nuevamente.");
      setLoadinActivateTransfer(false);
    }
  };
  const fetchSaldoDisponible = async () => {
    try {
      const user_id = localStorage.getItem("usuario_id");
      const token = localStorage.getItem("token");
      const response = await fetch(
        `https://99envios.app/api/online/consultar-saldo/${user_id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const data = await response.json();
      setSaldoDisponible(data.saldo_disponible);
    } catch (error) {
      message.error("Error al obtener el saldo disponible");
    }
  };

  const fetchTransferencias = async () => {
    try {
      const user_id = localStorage.getItem("usuario_id");
      const token = localStorage.getItem("token");
      const email = localStorage.getItem("email");
      if (!email) {
        message.error("Por favor, inicie sesión para ver las transferencias");
        return;
      }
      const bodyRequest = { correo: email };
      const response = await axios.post(
        "https://99envios.app/api/online/transferencias/mostrar",
        bodyRequest,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const data = response.data;
      setTransferenciasEnviadas(data.transferencias_enviadas || []);
      setTransferenciasRecibidas(data.transferencias_recibidas || []);
      setResumen(data.resumen || null);
    } catch (error) {
      message.error("Error al obtener el historial de transferencias");
    }
  };

  const fetchDetalleSucursal = async () => {
    try {
      if (!correoSucursal) {
        message.error("Por favor ingrese un correo");
        return;
      }

      const user_id = localStorage.getItem("usuario_id");
      const token = localStorage.getItem("token");

      const response = await fetch(
        `https://99envios.app/api/online/detalle-sucursal/${user_id}?correo=${encodeURIComponent(
          correoSucursal
        )}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) {
        throw new Error("Error al obtener detalles de la sucursal");
      }

      const data = await response.json();
      if (data && data.length > 0) {
        setDetalleSucursal(data[0]);
        setIsCorreoModalVisible(false);
        setIsDetalleModalVisible(true);
      } else {
        message.error("No se encontró información de la sucursal");
      }
    } catch (error) {
      message.error(error.message);
    }
  };

  const handleDetalleConfirm = () => {
    const email = correoSucursal.trim();
    const monto = montoTransferencia.trim();
    if (!email || !/\S+@\S+\.\S+/.test(email) || !monto) {
      message.error("Por favor complete todos los campos");
      return;
    }
    setIsCorreoModalVisible(false);
    setIsConfirmModalVisible(true);
  };

  const handlePreTransferencia = () => {
    if (isSubmitting) return; // Evitar múltiples clicks mientras se procesa

    if (!descripcion.trim()) {
      message.error("El concepto de la transferencia es obligatorio");
      return;
    }

    const montoATransferir = parseFloat(
      cleanCurrencyFormat(montoTransferencia)
    );
    if (!montoTransferencia || montoATransferir <= 0) {
      message.error("Por favor ingrese un monto válido");
      return;
    }

    // Verificar si hay saldo suficiente
    if (montoATransferir > saldoDisponible) {
      message.error("Saldo insuficiente para realizar la transferencia");
      return;
    }

    setIsConfirmModalVisible(true);
  };

  const realizarTransferencia = async (e) => {
    e.preventDefault();
    const email = correoSucursal.trim();
    const monto = montoTransferencia.trim();
    if (!email || !/\S+@\S+\.\S+/.test(email) || !monto) {
      message.error("Por favor complete todos los campos");
      return;
    }
    try {
      setIsSubmitting(true);
      //const user_id = localStorage.getItem("usuario_id");
      const token = localStorage.getItem("token");
      const emailOrigin = localStorage.getItem("email");

      const bodyRequest = {
        correo_origen: emailOrigin,
        correo_destino: email,
        monto: parseInt(monto),
        descripcion: descripcion.trim(),
      };
      const response = await axios.post(
        "https://99envios.app/api/online/transferencias/registrar",
        bodyRequest,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      setResponseSuccess(true);
      message.success("Transferencia realizada con éxito");

      // Limpiar estados y cerrar modales
      setIsConfirmModalVisible(false);
      setIsTransferenciaModalVisible(false);
      setCorreoSucursal("");
      setMontoTransferencia("");
      setDescripcion("");
      setDetalleSucursal(null);

      // Actualizar datos
      fetchSaldoDisponible();
      fetchTransferencias();
    } catch (error) {
      if (error.response) {
        // El servidor respondió con un status fuera del rango 2xx
        const status = error.response.status;
        const details = error.response.data?.details;

        // Extrae mensaje personalizado
        const mensajeError =
          details?.correo_destino ||
          details?.correo_origen ||
          error.response.data?.message ||
          "Ocurrió un error en la transferencia";

        message.error(mensajeError);
      } else if (error.request) {
        // La solicitud fue hecha pero no hubo respuesta
        message.error("Sin respuesta del servidor. Verifica tu conexión.");
      } else {
        // Algo pasó al preparar la solicitud
        message.error("Error al enviar la solicitud: " + error.message);
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  const columns = [
    {
      title: "Fecha",
      dataIndex: "fecha_transferencia",
      key: "fecha_transferencia",
      render: (text) => (
        <Tooltip title={new Date(text).toLocaleString()}>
          {new Date(text).toLocaleDateString()}
        </Tooltip>
      ),
    },
    {
      title: "Sucursal",
      key: "sucursal",
      render: (_, record) => {
        const sucursal =
          record.sucursal_destino?.nombre ||
          record.sucursal_origen?.nombre ||
          "Sin nombre";
        return <Badge status="processing" text={`Sucursal ${sucursal}`} />;
      },
    },
    {
      title: "Monto",
      dataIndex: "monto",
      key: "monto",
      render: (monto, record, index) => (
        <span
          style={{
            color: record.tipo === "enviada" ? "#ff4d4f" : "#52c41a",
            fontWeight: "bold",
            display: "flex",
            alignItems: "center",
            gap: "5px",
          }}
        >
          ${parseFloat(monto).toLocaleString()}{" "}
          {record.tipo === "enviada" ? "↑" : "↓"}
        </span>
      ),
    },
    {
      title: "Descripción",
      dataIndex: "descripcion",
      key: "descripcion",
      render: (text) => (
        <Tooltip title={text}>
          {text ? `${text.substring(0, 30)}...` : text}
        </Tooltip>
      ),
    },
  ];

  // Actualizar la configuración de la tabla con altura fija
  const tableProps = {
    bordered: true,
    size: "large",
    scroll: { x: true, y: 400 }, // Añadir scroll vertical
    pagination: {
      pageSize: 7,
      showSizeChanger: true,
      showTotal: (total, range) =>
        `${range[0]}-${range[1]} de ${total} transferencias`,
      pageSizeOptions: ["7", "10", "20", "50"],
      position: ["bottomCenter"], // Centrar la paginación
    },
  };
  const currencyFormatter = new Intl.NumberFormat("es-CO", {
    style: "currency",
    currency: "COP",
    minimumFractionDigits: 0,
  });

  // Modal para realizar transferencias
  const renderCorreoModal = () => {
    const monto = parseFloat(montoTransferencia || "0");
    const comision = monto * 0.005;

    return (
      <Modal
        title={
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <SendOutlined style={{ fontSize: "24px" }} />
            <span>Realizar transferencia</span>
          </div>
        }
        visible={isCorreoModalVisible}
        onCancel={() => {
          setIsCorreoModalVisible(false);
          setCorreoSucursal("");
          setMontoTransferencia("");
          setDescripcion("");
        }}
        className="custom-modal-transferencia"
        width={500}
        centered
        maskStyle={{ backgroundColor: "rgba(0, 0, 0, 0.6)" }}
        footer={null}
      >
        <div
          style={{
            backgroundColor: "#f0f5ff",
            padding: "15px",
            borderRadius: "8px",
            marginBottom: "20px",
            border: "1px solid #adc6ff",
          }}
        >
          <p style={{ margin: 0, fontWeight: "500", color: "#2f54eb" }}>
            El monto máximo de transferencia es de <strong>$10.000.000</strong>.
          </p>
          <p style={{ margin: 0, fontWeight: "500", color: "#2f54eb" }}>
            Solo puedes hacer <strong>1 transferencia por día hábil</strong>.
          </p>
        </div>

        <p>Ingrese el correo de la sucursal y el monto que desea transferir:</p>

        <form style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
          <input
            type="email"
            placeholder="Correo destinatario"
            value={correoSucursal}
            onChange={(e) => setCorreoSucursal(e.target.value)}
          />

          <input
            type="number"
            placeholder="Monto a enviar"
            value={montoTransferencia}
            onChange={(e) => setMontoTransferencia(e.target.value)}
          />

          {monto > 0 && (
            <>
              <p style={{ margin: 0, color: "#8c8c8c" }}>
                Monto ingresado:{" "}
                <strong>{currencyFormatter.format(monto)}</strong>
              </p>
              <p style={{ margin: 0, color: "#8c8c8c", fontStyle: "italic" }}>
                Comisión (0.5%):{" "}
                <strong>{currencyFormatter.format(comision)}</strong>
              </p>
            </>
          )}

          <input
            type="text"
            placeholder="Descripción de la transferencia"
            value={descripcion}
            onChange={(e) => setDescripcion(e.target.value)}
          />
          <div className="button-confirm-trasnfer-sucursal-container">
            <Button
              type="primary"
              onClick={handleDetalleConfirm}
              loading={isSubmitting}
            >
              Confirmar
            </Button>
          </div>
        </form>
      </Modal>
    );
  };
  // Modal para confirmar detalles
  const renderDetalleModal = () => (
    <Modal
      title={
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <InfoCircleOutlined style={{ fontSize: "24px" }} />
          <span>Detalles de la Sucursal</span>
        </div>
      }
      visible={isDetalleModalVisible}
      onOk={handleDetalleConfirm}
      onCancel={() => setIsDetalleModalVisible(false)}
      okText="Continuar"
      cancelText="Cancelar"
      className="custom-modal-transferencia"
      width={600}
      centered
    >
      {detalleSucursal && (
        <div className="detalle-sucursal">
          <p>
            <strong>Código:</strong> {detalleSucursal.codigo_sucursal}
          </p>
          <p>
            <strong>Nombre:</strong> {detalleSucursal.nombre_sucursal}
          </p>
          <p>
            <strong>Correo:</strong> {detalleSucursal.correo}
          </p>
          <p>
            <strong>Dirección:</strong> {detalleSucursal.direccion}
          </p>
          <p>
            <strong>Teléfono:</strong> {detalleSucursal.telefono}
          </p>
        </div>
      )}
    </Modal>
  );

  // Modal para realizar transferencia
  const renderTransferenciaModal = () => (
    <Modal
      title={
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <DollarOutlined style={{ fontSize: "24px" }} />
          <span>Realizar Transferencia</span>
        </div>
      }
      visible={isTransferenciaModalVisible}
      onOk={handlePreTransferencia}
      onCancel={() => setIsTransferenciaModalVisible(false)}
      okText="Transferir"
      cancelText="Cancelar"
      className="custom-modal-transferencia"
      width={500}
      centered
    >
      <Form layout="vertical">
        <div
          style={{
            marginBottom: "20px",
            padding: "10px",
            background: "#f5f5f5",
            borderRadius: "8px",
          }}
        >
          <strong>Saldo Disponible:</strong> ${saldoDisponible.toLocaleString()}
        </div>
        <Form.Item label="Monto a Transferir">
          <Input
            value={formatToCurrency(montoTransferencia)}
            onChange={(e) => {
              const valor = cleanCurrencyFormat(e.target.value);
              if (parseFloat(valor) > saldoDisponible) {
                message.warning("El monto excede el saldo disponible");
              }
              setMontoTransferencia(valor);
            }}
            prefix="$"
            placeholder="0"
            status={
              parseFloat(cleanCurrencyFormat(montoTransferencia)) >
              saldoDisponible
                ? "error"
                : ""
            }
          />
          {parseFloat(cleanCurrencyFormat(montoTransferencia)) >
            saldoDisponible && (
            <div
              style={{ color: "#ff4d4f", fontSize: "12px", marginTop: "4px" }}
            >
              El monto excede el saldo disponible
            </div>
          )}
        </Form.Item>
        <Form.Item
          label="Concepto de transferencia"
          required
          tooltip="Este campo es obligatorio"
        >
          <TextArea
            value={descripcion}
            onChange={(e) => setDescripcion(e.target.value)}
            placeholder="Ingrese una descripción para la transferencia"
            rows={4}
            status={!descripcion.trim() ? "error" : ""}
          />
        </Form.Item>
      </Form>
    </Modal>
  );

  // Añadir el modal de confirmación
  const renderConfirmModal = () => {
    const comision = montoTransferencia * 0.005;
    const montoReal = montoTransferencia - comision;
    return (
      <Modal
        title={
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <CheckCircleOutlined
              style={{ fontSize: "24px", color: "#52c41a" }}
            />
            <span>Confirmar Transferencia</span>
          </div>
        }
        visible={isConfirmModalVisible}
        onOk={realizarTransferencia}
        onCancel={() => {
          !isSubmitting && setIsConfirmModalVisible(false);
          setCorreoSucursal("");
          setMontoTransferencia("");
          setDescripcion("");
        }}
        // okText="Confirmar"
        // cancelText="Cancelar"
        okButtonProps={{
          loading: isSubmitting,
          disabled: isSubmitting,
        }}
        cancelButtonProps={{
          disabled: isSubmitting,
        }}
        closable={!isSubmitting}
        maskClosable={!isSubmitting}
        keyboard={!isSubmitting}
        className="custom-modal-transferencia"
        width={500}
        footer={null}
        centered
      >
        <div className="confirm-details">
          <h3>Por favor confirma los siguientes datos:</h3>
          <div className="detail-item">
            <strong>Sucursal Destino:</strong>
            <p>{correoSucursal}</p>
          </div>
          {/* <div className="detail-item">
          <strong>Código Sucursal:</strong>
          <p>{detalleSucursal?.codigo_sucursal}</p>
        </div> */}
          {/* <div className="detail-item">
          <strong>Correo:</strong>
          <p>{detalleSucursal?.correo}</p>
        </div> */}
          <div className="detail-item">
            <strong>Monto a Transferir:</strong>
            <p className="monto">${formatToCurrency(montoReal)}</p>
          </div>
          <div className="detail-item">
            <strong>Comisión:</strong>
            <p className="monto">${formatToCurrency(comision)}</p>
          </div>
          <div className="detail-item">
            <strong>Concepto:</strong>
            <p>{descripcion}</p>
          </div>
          <div className="button-transferencia-sucursal-container">
            <Button
              type="primary"
              loading={isSubmitting}
              onClick={realizarTransferencia}
            >
              Enviar
            </Button>
          </div>
        </div>
      </Modal>
    );
  };

  const modalToAcceptTrasnferModule = () => {
    return (
      <Modal
        title="Solicitud de activación del módulo de transferencias"
        visible="true"
        footer={null}
        width={"50vw"}
        closable={false}
        maskClosable={false}
        keyboard={false}
      >
        <div style={{ fontSize: "15px", lineHeight: "1.8", color: "#333" }}>
          <p>
            Por medio de este modal, acpeto la activación de mi cuenta asociada
            a <strong>99envíos</strong>, la cual está registrada con mi nombre,
            correo electrónico y número de sucursal correspondientes, para poder
            realizar transferencias entre sucursales.
          </p>
          <p>
            Declaro que asumo <strong>toda la responsabilidad</strong> por las
            acciones que se realicen a partir de esta activación. Confirmo que
            cada solicitud que se realice será bajo mi consentimiento.
          </p>
          <p>
            Soy consciente de que esta acción{" "}
            <strong>no se puede revertir</strong>, y me comprometo a hacer un
            uso adecuado del módulo, respetando las políticas y normativas
            establecidas.
          </p>
          <div className="button-accept-trasnfer-sucursal-container">
            <Button
              type="primary"
              onClick={activateTransferModule}
              loading={loadingActivationTransfer}
            >
              Aceptar
            </Button>
          </div>
        </div>
      </Modal>
    );
  };
  if (isActiveTrasnferSucursal === 0) {
  return (
    <div style={{ display:'flex', justifyContent:'center', alignItems:'center' }}>
      <Spin size="large" />
    </div>
  );
}
  return isActiveTrasnferSucursal === 1 ? (
    <>
      <NavbarMex title="Transferencias Sucursal" />
      <div className="transferencia-container">
        <Card className="saldo-card">
          <div className="saldo-header">
            <DollarOutlined className="saldo-icon" />
            <div>
              <h2>Saldo Disponible</h2>
              <h3>${saldoDisponible.toLocaleString()}</h3>
            </div>
          </div>
          <Row gutter={[16, 16]}>
            <Col xs={24} sm={24} md={24} lg={12} xl={6}>
              <Card>
                <Statistic
                  title="Transferencias Enviadas"
                  value={resumen !== null && resumen.total_enviadas}
                  valueStyle={{ color: "#1890ff" }}
                />
              </Card>
            </Col>
            <Col xs={24} sm={24} md={24} lg={12} xl={6}>
              <Card>
                <Statistic
                  title="Transferencias Recibidas"
                  value={resumen !== null && resumen.total_recibidas}
                  valueStyle={{ color: "#52c41a" }}
                />
              </Card>
            </Col>
            <Col xs={24} sm={24} md={24} lg={12} xl={6}>
              <Card>
                <Statistic
                  title="Monto Enviado"
                  value={resumen !== null && resumen.monto_total_enviado}
                  prefix="$"
                  precision={2}
                  valueStyle={{ color: "#faad14" }}
                />
              </Card>
            </Col>
            <Col xs={24} sm={24} md={24} lg={12} xl={6}>
              <Card>
                <Statistic
                  title="Monto Recibido"
                  value={resumen !== null && resumen.monto_total_recibido}
                  prefix="$"
                  precision={2}
                  valueStyle={{ color: "#13c2c2" }}
                />
              </Card>
            </Col>
          </Row>
        </Card>

        <Button
          type="primary"
          icon={<SendOutlined />}
          onClick={() => setIsCorreoModalVisible(true)}
          className="nueva-transferencia-btn"
          size="large"
        >
          Nueva Transferencia
        </Button>

        <div className="historial-transferencias">
          <Card
            title={
              <div className="card-title">
                <span>Transferencias Enviadas</span>
                <Tooltip title="Transferencias realizadas a otras sucursales">
                  <InfoCircleOutlined style={{ marginLeft: 8 }} />
                </Tooltip>
              </div>
            }
            className="transferencias-card"
          >
            <Table
              {...tableProps}
              dataSource={transferenciasEnviadas.map((t) => ({
                ...t,
                tipo: "enviada",
              }))}
              columns={columns}
              rowKey="id"
              locale={{
                emptyText: (
                  <Empty
                    description="No hay transferencias enviadas"
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                  />
                ),
              }}
            />
          </Card>

          <Card
            title={
              <div className="card-title">
                <span>Transferencias Recibidas</span>
                <Tooltip title="Transferencias recibidas de otras sucursales">
                  <InfoCircleOutlined style={{ marginLeft: 8 }} />
                </Tooltip>
              </div>
            }
            className="transferencias-card"
          >
            <Table
              {...tableProps}
              dataSource={transferenciasRecibidas.map((t) => ({
                ...t,
                tipo: "recibida",
              }))}
              columns={columns}
              rowKey="id"
              locale={{
                emptyText: (
                  <Empty
                    description="No hay transferencias recibidas"
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                  />
                ),
              }}
            />
          </Card>
        </div>

        {renderCorreoModal()}
        {renderDetalleModal()}
        {renderTransferenciaModal()}
        {renderConfirmModal()}
      </div>
    </>
  ) : (
    modalToAcceptTrasnferModule()
  );
};

export default TransferenciaSucursal;
